<template>
  
  <div class="ui segment animated fadeIn">

    <form class="ui form">      
      <div class="fields">
        <div class="two wide field">
          <label class="form-label">Emite Laudo</label>
          <span>{{ customer.issueReport == 'S' ? 'Sim' : 'Não' }}</span>
        </div>             
        <div class="two wide field">
          <label class="form-label">Aceita Pallets</label>
          <span></span>
        </div>
        <div class="two wide field">
          <label class="form-label">Aceita Fat. Parcial</label>
          <span></span>
        </div>             
      </div>
    </form>

  </div>

</template>

<script>

  export default {    
    props: ["customer"],
  }

</script>

